/**
 * @generated SignedSource<<3a59baf26afd8d343a1afbb7edbb2830>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SocialLinksFields_User$data = {
  readonly profile: {
    readonly urlBlog: string | null | undefined;
    readonly urlDribbble: string | null | undefined;
    readonly urlGithub: string | null | undefined;
    readonly urlLinkedin: string | null | undefined;
  } | null | undefined;
  readonly resume: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SocialLinksEditDialog_User">;
  readonly " $fragmentType": "SocialLinksFields_User";
};
export type SocialLinksFields_User$key = {
  readonly " $data"?: SocialLinksFields_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"SocialLinksFields_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SocialLinksFields_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlBlog",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlDribbble",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlGithub",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLinkedin",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Resume",
      "kind": "LinkedField",
      "name": "resume",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SocialLinksEditDialog_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c889a514dda644fd5f219181e92cfdca";

export default node;
